import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hidePassword = true;
  public add:any={};

  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private appservice: AppService
  ) {}

  ngOnInit(): void {}

 onSubmit() {
//   const username = this.loginForm.get('username')?.value;
//   const password = this.loginForm.get('password')?.value;

//   this.appService.getlogin(this.loginForm.value.username, this.loginForm.value.password)
//   .subscribe({
//     next: (res) => {
//       if (res && res !== "Invalid username or password") {
//         console.log('Login success', res);
//         this.router.navigate(['/home']);
//       } else {
//         this.toastr.error('Invalid username or password');
//       }
//     },
//     error: (err) => {
//       console.error('Login failed', err);
//       this.toastr.error(err.message || 'Server error during login');
//     }
//   });

}
 getlogin() {
    // if (!this.validate()) {
    //   this.toastr.warning(this.ErrorMessage);
    //   return;
    // }

    this.appservice.getTable(
      `api/LOGIN/getlogin?Username=${this.add.UserName}&Password=${this.add.Password}`
    ).subscribe(
      (res: any) => {
        if (res != "") {
          const result = JSON.parse(res);
          if (result.record && result.record.length > 0) {
            this.appservice.username = result.record[0]["um_vLoginId"];
            
            this.toastr.success('Login Successfully', 'Success');
            this.router.navigate(['/home']);
          } else {
            this.toastr.error('Invalid username or password', 'Login Failed');
          }
        } else {
          this.toastr.error('No user found', 'Login Failed');
        }
      },
      (err) => {
        console.error(err);
        this.toastr.error('Server error', 'Error');
      }
    );
  }

}
